import React from 'react';

import { DangerText } from '../ContractText';

interface SerllerPayBuyerAgentFeeProps {
  sellerAssistanceClosingCosts?: number;
  buyerAgentCompensation?: number;
  offerPrice?: number;
}

const SerllerPayBuyerAgentFee = ({
  sellerAssistanceClosingCosts,
  buyerAgentCompensation,
  offerPrice,
}: SerllerPayBuyerAgentFeeProps) => {
  return (
    <span>
      Seller to credit {buyerAgentCompensation}% of ${offerPrice} to buyer at
      closing, covering first the Unbeatable Loans LLC fee. Additionally, a
      seller credit of ${sellerAssistanceClosingCosts} will be applied to
      closing costs, down payments, inspection fees, and other associated costs.
    </span>
  );
};

export default SerllerPayBuyerAgentFee;
